//import React from 'react';
import DBEdit from './DBEdit';

export default DBEdit;